// Servizio dominio CORSI (Educational): vetrina pubblica + gestione CRM (admin/stakeholder).
import { api, unwrap } from './client';

const g = (path, params, config) => unwrap(api.get(path, { params, ...(config || {}) }));
const p = (path, body, config) => unwrap(api.post(path, body, config));
const u = (path, body, config) => unwrap(api.put(path, body, config));
const d = (path, config) => unwrap(api.delete(path, config));

export const coursesService = {
  // ---- Vetrina pubblica ----
  publicList: (params) => g('/courses/public', params || {}),
  publicCategories: () => g('/courses/public/categories'),
  publicByOwner: (ownerId) => g(`/courses/public/by-owner/${ownerId}`),
  publicGet: (idOrSlug) => g(`/courses/public/${idOrSlug}`),
  // Checkout Stripe reale (Payment Element, anche ospite senza login)
  checkoutIntent: (body) => p('/courses/public/checkout/intent', body),
  checkoutConfirm: (orderId) => p('/courses/public/checkout/confirm', { order_id: orderId }),

  // ---- Modulo (stakeholder) ----
  moduleStatus: () => g('/courses/module'),
  activateModule: () => p('/courses/module/activate'),

  // ---- Gestione corsi (stakeholder abilitato + admin) ----
  list: (params) => g('/courses', params),
  get: (cid) => g(`/courses/${cid}`),
  create: (body) => p('/courses', body),
  update: (cid, body) => u(`/courses/${cid}`, body),
  setStatus: (cid, status) => p(`/courses/${cid}/status`, { status }),
  remove: (cid) => d(`/courses/${cid}`),

  // ---- Ordini / iscrizioni ----
  ordersOverview: () => g('/courses/orders/overview'),
  courseOrders: (cid) => g(`/courses/${cid}/orders`),
  customerOrders: () => g('/courses/customer/orders'),

  // ---- Categorie (admin) ----
  categories: () => g('/courses/categories'),
  createCategory: (body) => p('/courses/categories', body),
  updateCategory: (slug, body) => u(`/courses/categories/${slug}`, body),
  deleteCategory: (slug) => d(`/courses/categories/${slug}`),

  // ---- Approvazioni modulo (admin) ----
  moduleRequests: (status) => g('/courses/admin/module-requests', status ? { status } : {}),
  decideModule: (ownerId, approve, note) => p(`/courses/admin/module-requests/${ownerId}/decide`, { approve, note }),
};

// URL pubblico condivisibile del corso.
export const coursePublicUrl = (slug) => `${window.location.origin}/educational/corso/${slug}`;
